import { combineReducers, configureStore } from '@reduxjs/toolkit';
import userManagementReducer from './slices/userManagementSlice';
import impersonationReducer from './slices/impersonationSlice';
import { userManagementApi } from './api/userManagementApi';
import storage from 'redux-persist/lib/storage';
import { persistReducer, persistStore } from 'redux-persist';
import { setupListeners } from '@reduxjs/toolkit/query';
import {
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER
} from 'redux-persist';
import { giftApi } from './api/giftApi';
import { analyticsApi } from './api/analyticsApi';
import { affiliateReportApi } from './api/affiliateReportApi';

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['impersonation']
};

const impersonationPersistConfig = {
  key: 'impersonation',
  storage,
  whitelist: ['impersonated', 'superadmin', 'publisherData']
};

const rootReducer = combineReducers({
  userManagement: userManagementReducer,
  impersonation: persistReducer(impersonationPersistConfig, impersonationReducer),
  [userManagementApi.reducerPath]: userManagementApi.reducer,
  [giftApi.reducerPath]: giftApi.reducer,
  [analyticsApi.reducerPath]: analyticsApi.reducer,
  [affiliateReportApi.reducerPath]: affiliateReportApi.reducer
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER]
      }
    }).concat(userManagementApi.middleware, giftApi.middleware, analyticsApi.middleware, affiliateReportApi.middleware)
});

setupListeners(store.dispatch);

export const persistor = persistStore(store);